import { useState } from 'react';

import { TFunction } from 'i18next';

import { Focusable, Tooltip } from '@cfa/react-core';
import { InfoOutline } from '@cfa/system-icons';

import useAuth from '@/hooks/useAuth';
import { useBreakpointDown } from '@/hooks/useMediaQuery';

const AnswersChip: React.FC<{ t: TFunction }> = ({ t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: auth } = useAuth();
  const isLicensee = auth?.isLicensee ?? false;
  const isMobile = useBreakpointDown('md');
  // CFA Tooltip.Placements omits Aria secondary-axis variants; runtime accepts
  // `right top` (Figma left-top caret — hangs down, not vertical-center).
  const placement = (isMobile ? 'bottom' : 'right top') as Tooltip.Placements;

  return (
    <div className="flex items-center gap-1.5">
      <p
        className="text-variant-h4 text-[#1E272F]"
        data-testid="SmartSearchAnswersChip"
      >
        {t('AISearchPOC.pathwaySmartSearch')}
      </p>
      <Tooltip.Root delay={250} isOpen={isOpen} onOpenChange={setIsOpen}>
        <Focusable>
          <InfoOutline
            className="cursor-pointer"
            onClick={() => setIsOpen(prev => !prev)}
          />
        </Focusable>
        <Tooltip.Content
          placement={placement}
          className="text-variant-body2 max-w-[350px] whitespace-pre-line"
        >
          {isLicensee
            ? t('AISearchPOC.disclaimerLicensee')
            : t('AISearchPOC.disclaimer')}
        </Tooltip.Content>
      </Tooltip.Root>
    </div>
  );
};

export default AnswersChip;
